/**
 * Social Proof Toasts
 * Simulated purchase notifications — matches components/social-proof-toasts.tsx
 *
 * The first toast doesn't appear for 8-12s, so we can safely defer all setup
 * (city/product array allocation, querySelectors, listener attach) to idle
 * to keep the main thread free during LCP.
 */
(function () {
  'use strict';

  var rIC = window.requestIdleCallback || function (cb) { return setTimeout(cb, 200); };
  rIC(init, { timeout: 3000 });

  function init() {
  var toastContainer = document.querySelector('[data-social-proof-toast]');
  var imgWatermelon = toastContainer ? toastContainer.getAttribute('data-img-watermelon') : '';
  var imgMint = toastContainer ? toastContainer.getAttribute('data-img-mint') : '';
  var imgCitrus = toastContainer ? toastContainer.getAttribute('data-img-citrus') : '';
  var imgGinger = toastContainer ? toastContainer.getAttribute('data-img-ginger') : '';

  var PRODUCTS = [
    { name: '5-Pack Watermelon', img: imgWatermelon },
    { name: '5-Pack Cool Mint', img: imgMint },
    { name: '5-Pack Cucumber Citrus', img: imgCitrus },
    { name: '5-Pack Ginger Lime', img: imgGinger },
    { name: '4-Pack Mixed Flavors', img: imgWatermelon }
  ];

  var CITIES = [
    'Los Angeles, CA', 'Austin, TX', 'Miami, FL', 'New York, NY', 'Denver, CO',
    'Chicago, IL', 'Nashville, TN', 'San Diego, CA', 'Portland, OR', 'Seattle, WA',
    'Phoenix, AZ', 'Atlanta, GA', 'Dallas, TX', 'Charlotte, NC', 'Tampa, FL',
    'Scottsdale, AZ', 'Boulder, CO', 'Honolulu, HI', 'Salt Lake City, UT',
    'San Francisco, CA', 'Brooklyn, NY', 'Raleigh, NC', 'Boise, ID', 'Savannah, GA',
    'Charleston, SC', 'San Antonio, TX', 'Jacksonville, FL', 'Omaha, NE',
    'Minneapolis, MN', 'St. Louis, MO', 'Kansas City, MO', 'Tucson, AZ',
    'Las Vegas, NV', 'Reno, NV', 'Albuquerque, NM', 'Sacramento, CA', 'Irvine, CA',
    'Huntington Beach, CA', 'Bend, OR', 'Asheville, NC', 'Pittsburgh, PA',
    'Philadelphia, PA', 'Boston, MA', 'Detroit, MI', 'Grand Rapids, MI',
    'Madison, WI', 'Indianapolis, IN', 'Columbus, OH', 'Richmond, VA',
    'Virginia Beach, VA', 'Wilmington, NC', 'Fort Worth, TX', 'Houston, TX',
    'Chattanooga, TN', 'Memphis, TN', 'Knoxville, TN', 'Orlando, FL',
    'Fort Lauderdale, FL', 'St. Petersburg, FL', 'Sarasota, FL', 'Destin, FL',
    'Little Rock, AR', 'Oklahoma City, OK', 'Tulsa, OK', 'Spokane, WA',
    'Tacoma, WA', 'Eugene, OR', 'Santa Fe, NM', 'Missoula, MT',
    'Anchorage, AK', 'Burlington, VT', 'Providence, RI', 'New Haven, CT',
    'Annapolis, MD', 'Lexington, KY', 'Louisville, KY', 'Greenville, SC',
    'Columbia, SC', 'Birmingham, AL'
  ];

  var TIMES = [
    'just now', '1 min ago', '2 min ago', '3 min ago', '5 min ago',
    '6 min ago', '8 min ago', '10 min ago', '12 min ago', '15 min ago',
    '18 min ago', '20 min ago', '25 min ago', '30 min ago', '35 min ago',
    '40 min ago', '45 min ago', '1 hour ago'
  ];

  var toastEl = document.querySelector('[data-social-proof-toast]');
  if (!toastEl) return;

  var imgEl = toastEl.querySelector('[data-toast-img]');
  var cityEl = toastEl.querySelector('[data-toast-city]');
  var productEl = toastEl.querySelector('[data-toast-product]');
  var timeEl = toastEl.querySelector('[data-toast-time]');

  // Don't show on checkout or account pages
  var path = window.location.pathname;
  if (path.indexOf('/checkout') === 0 || path.indexOf('/account') === 0) return;

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  var hideTimer = null;

  function showToast() {
    var product = pick(PRODUCTS);
    var city = pick(CITIES);
    var time = pick(TIMES);

    if (imgEl) imgEl.src = product.img;
    if (cityEl) cityEl.textContent = city;
    if (productEl) productEl.textContent = product.name;
    if (timeEl) timeEl.textContent = time;

    resetTransform();
    toastEl.classList.add('is-visible');

    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(hideToast, 4000);
  }

  function hideToast() {
    toastEl.classList.remove('is-visible');
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    // Reset any swipe transform after the hide animation completes.
    setTimeout(resetTransform, 500);
  }

  function resetTransform() {
    toastEl.style.transition = '';
    toastEl.style.transform = '';
    toastEl.style.opacity = '';
  }

  /* ---- Swipe to dismiss (horizontal only) ----
     Vertical pans are left to the browser so page scrolling on top of the
     toast keeps working. We only intercept once the user's gesture clearly
     reads as horizontal — see the axis-detection logic in onPointerMove. */

  var dragStartX = 0;
  var dragStartY = 0;
  var dragDx = 0;
  var dragDy = 0;
  var pointerId = null;
  var pointerActive = false; // a pointer is down, but we may not yet be swiping
  var swiping = false;       // we've decided this is a horizontal swipe
  var aborted = false;       // we've decided this gesture is for the page (vertical)
  var swiped = false;
  var SWIPE_THRESHOLD = 80;
  var AXIS_LOCK_DELTA = 10;

  function onPointerDown(e) {
    if (!toastEl.classList.contains('is-visible')) return;
    // Mouse: only respond to primary button.
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    pointerId = e.pointerId;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    dragDx = 0;
    dragDy = 0;
    pointerActive = true;
    swiping = false;
    aborted = false;
    swiped = false;
    // Pause auto-hide while user interacts.
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  }

  function onPointerMove(e) {
    if (!pointerActive || e.pointerId !== pointerId || aborted) return;
    dragDx = e.clientX - dragStartX;
    dragDy = e.clientY - dragStartY;

    if (!swiping) {
      var ax = Math.abs(dragDx);
      var ay = Math.abs(dragDy);
      // Wait for clear intent before deciding.
      if (ax < AXIS_LOCK_DELTA && ay < AXIS_LOCK_DELTA) return;
      if (ay >= ax) {
        // Vertical intent — let the browser scroll, stop tracking this gesture.
        aborted = true;
        // Resume auto-hide; user isn't dismissing.
        hideTimer = setTimeout(hideToast, 4000);
        return;
      }
      // Horizontal swipe confirmed — capture pointer and take over.
      swiping = true;
      toastEl.style.transition = 'none';
      if (toastEl.setPointerCapture) {
        try { toastEl.setPointerCapture(pointerId); } catch (_) {}
      }
    }

    var width = toastEl.offsetWidth || 320;
    var opacity = Math.max(0, 1 - Math.abs(dragDx) / width);
    toastEl.style.transform = 'translateX(' + dragDx + 'px)';
    toastEl.style.opacity = String(opacity);
    if (e.cancelable) e.preventDefault();
  }

  function onPointerEnd(e) {
    if (!pointerActive || (e && e.pointerId !== pointerId)) return;
    pointerActive = false;

    if (!swiping) {
      // Either aborted (vertical) or never moved past axis-lock — nothing to animate.
      pointerId = null;
      return;
    }

    toastEl.style.transition = 'transform 0.25s ease-out, opacity 0.25s ease-out';

    if (Math.abs(dragDx) > SWIPE_THRESHOLD) {
      swiped = true;
      var dir = dragDx > 0 ? 1 : -1;
      var dist = toastEl.offsetWidth + 40;
      toastEl.style.transform = 'translateX(' + (dir * dist) + 'px)';
      toastEl.style.opacity = '0';
      setTimeout(hideToast, 250);
    } else {
      toastEl.style.transform = '';
      toastEl.style.opacity = '';
      hideTimer = setTimeout(hideToast, 4000);
    }

    swiping = false;
    pointerId = null;
  }

  toastEl.addEventListener('pointerdown', onPointerDown);
  toastEl.addEventListener('pointermove', onPointerMove);
  toastEl.addEventListener('pointerup', onPointerEnd);
  toastEl.addEventListener('pointercancel', onPointerEnd);

  // Click to dismiss (only on a tap — not after a swipe or scroll attempt).
  toastEl.addEventListener('click', function () {
    if (swiped || Math.abs(dragDx) > 4 || Math.abs(dragDy) > 4) return;
    hideToast();
  });

  // First toast after 8-12 seconds, then every 40-50 seconds
  var initialDelay = 8000 + Math.random() * 4000;
  setTimeout(function () {
    showToast();
    setInterval(function () {
      showToast();
    }, 40000 + Math.random() * 10000);
  }, initialDelay);
  }
})();
